/* Pure helper for the PWA update "flush before activate" contract.
 *
 * Given the completion promises registered by open editors (via
 * psc:flush-before-update → detail.waitUntil), await them ALL and report:
 *   "ok"      → every save resolved; safe to activate the new worker + reload.
 *   "failed"  → at least one save REJECTED (durable local write failed).
 *   "timeout" → saves did not settle within timeoutMs.
 * Only "ok" may proceed to activation. Dispatching the event is NOT proof of a
 * save — the caller must await this result.
 */
export const FLUSH_TIMEOUT_MS = 8000;

export async function awaitFlushWithTimeout(tasks, timeoutMs = FLUSH_TIMEOUT_MS) {
  if (!tasks || tasks.length === 0) return "ok";
  const settled = Promise.allSettled(tasks).then((r) =>
    r.some((x) => x.status === "rejected") ? "failed" : "ok"
  );
  const timed = new Promise((res) => setTimeout(() => res("timeout"), timeoutMs));
  return Promise.race([settled, timed]);
}
